<template>
    <div>
        <div class="treerow lvl3" v-on:click="$set(source,'expanded', !source.expanded)">
            <hsc-menu-context-menu class="menucontainer">
                <span :class="'db'+(source.expanded?' expanded' :' collapsed')">{{source.tablename}}</span>
                <div slot="contextmenu" style="z-index:8">
                    <hsc-menu-item label="Select top 1000" v-on:click.native.stop="SelectTop1000Edges()" />
                    <hsc-menu-item label="Create Edge" v-on:click.native.stop="ScriptCreateEdge()" />
                    <hsc-menu-item label="Delete" v-on:click.native.stop="DeleteTable()" />
                </div>
            </hsc-menu-context-menu>
        </div>
        <div v-if="source.expanded">
            <div class="treerow lvl4" v-for="fld in source.fields" v-bind:key="fld.name">
                <span class="db">{{fld.name}}</span><span class="db otherinfo">{{' '}}[{{typemap[fld.type+'-'+fld.subtype]||(fld.type+'-'+fld.subtype)}}] -> {{fld.linktable}}</span>
            </div>           
        </div>
        <!-- 
        -->
    </div>  
</template>

<script>
import {commonMixin} from '../../common.js'
export default {
    name: 'dynamic-size-edge',
    mixins: [commonMixin],
    props: {
        source: {
            type: Object,
            default () {
            return {
            }
            }
        },
        db: {
            type: Object,
        }
    },
    methods: {
        SelectTop1000Edges(){
          console.log('SelectTop1000Edges');
          this.dispatch('App','selectEdge1000',this.source,this.db)
        },
        ScriptCreateEdge(){
            console.log('ScriptCreateEdge');
          this.dispatch('App','createEdge',this.source)
        },
        DeleteTable() {
          console.log('DeleteTable');
          this.dispatch('App','deleteTable',this.db,this.source)
        },
    }
}
</script>

<style>

</style>